import { BaseApi } from './base.api.js';

export class RecoveryResourcesApi extends BaseApi {
    constructor(client, basePath = '/recovery-resources') {
        super(client, basePath);
    }
}
